import * as React from 'react'
import './debug.scss'

function DebugHeader () {
  return <div className='debug-header'>Debug</div>
}

export default DebugHeader
